import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import { fetchLegacyAnalysisJob } from './fetchLegacyAnalysisJob';
import type { mediaKeys } from './mediaKeys';

type TParams = QueryFunctionContext<ReturnType<typeof mediaKeys.legacyAnalysisJob>>;

export const createFetchLegacyAnalysisJobQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ mediaId }], signal }: TParams) =>
    (await fetchLegacyAnalysisJob(call, mediaId, signal)) || null;
